import moment from "moment"

const initialState = {
  isLoading: false,
  repairReceivedNotes: [],
  totalRrns: 0,
  totalPages: 0,
  currentRrn: null,
  newRrn: {
    nonGP: false,
    dateReceived: moment().format("YYYY-MM-DD"),
    timeReceived: moment().format("HH:mm"),
    invoiceNumber: "",
    customerCompany: "",
    address: "",
    telephone: "",
    email: "",
    itemReceived: [],
    receivedBy: "",
    initialObservations: "",
  },
}

const RepairReceivedNoteReducer = (state = initialState, action) => {
  switch (action.type) {
    case "SET_RRN_LOADING":
      return {
        ...state,
        isLoading: action.data,
      }

    case "SET_RRNS":
      return {
        ...state,
        repairReceivedNotes: action.data,
      }

    case "SET_TOTAL_RRNS":
      return {
        ...state,
        totalRrns: action.data,
      }

    case "SET_RRN_TOTAL_PAGES":
      return {
        ...state,
        totalPages: action.data,
      }

    case "SET_CURRENT_RRN":
      return {
        ...state,
        currentRrn: action.data,
      }

    case "SET_RRN_NON_GP":
      return {
        ...state,
        newRrn: { ...state.newRrn, nonGP: action.data },
      }

    case "SET_RRN_DATE_RECEIVED":
      return {
        ...state,
        newRrn: { ...state.newRrn, dateReceived: action.data },
      }

    case "SET_RRN_TIME_RECEIVED":
      return {
        ...state,
        newRrn: { ...state.newRrn, timeReceived: action.data },
      }

    case "SET_RRN_INVOICE_NUMBER":
      return {
        ...state,
        newRrn: { ...state.newRrn, invoiceNumber: action.data },
      }

    case "SET_RRN_CUSTOMER_COMPANY":
      return {
        ...state,
        newRrn: { ...state.newRrn, customerCompany: action.data },
      }

    case "SET_RRN_CUSTOMER_ADDRESS":
      return {
        ...state,
        newRrn: { ...state.newRrn, address: action.data },
      }

    case "SET_RRN_CUSTOMER_TELEPHONE":
      return {
        ...state,
        newRrn: { ...state.newRrn, telephone: action.data },
      }

    case "SET_RRN_CUSTOMER_EMAIL":
      return {
        ...state,
        newRrn: { ...state.newRrn, email: action.data },
      }

    case "SET_RRN_ITEMS":
      return {
        ...state,
        newRrn: { ...state.newRrn, itemReceived: action.data },
      }

    case "SET_RRN_RECEIVED_BY":
      return {
        ...state,
        newRrn: { ...state.newRrn, receivedBy: action.data },
      }

    case "SET_INITIAL_OBSERVATIONS":
      return {
        ...state,
        newRrn: { ...state.newRrn, initialObservations: action.data },
      }

    case "ADD_ITEM_RECEIVED":
      return {
        ...state,
        newRrn: {
          ...state.newRrn,
          itemReceived: [...state.newRrn.itemReceived, action.payload],
        },
      }

    case "UPDATE_ITEM_RECEIVED":
      return {
        ...state,
        newRrn: {
          ...state.newRrn,
          itemReceived: state.newRrn.itemReceived.map((item, i) =>
            i === action.payload.index ? action.payload.item : item
          ),
        },
      }

    case "REMOVE_ITEM_RECEIVED":
      return {
        ...state,
        newRrn: {
          ...state.newRrn,
          itemReceived: state.newRrn.itemReceived.filter(
            (_, i) => i !== action.payload
          ),
        },
      }

    case "CLEAR_NEW_RRN":
      return {
        ...state,
        newRrn: { ...initialState.newRrn },
      }

    default:
      return state
  }
}

export default RepairReceivedNoteReducer
